import { useMemo } from "react";
import { When } from "react-if";

import { Card } from "../../../../common/Atoms/Card";
import { classNames } from "../../../../common/lib/classNames";
import { useCurrentEscalation } from "../../../hooks/useCurrentEscalation";
import { Heading } from "../../../../common/Atoms/Typography/Heading";
import { ContactStatsDisplay } from "../../Molecules/ContactStatsDisplay";
import { CallToolbarButton, useClickToCall } from "../../CRM/ContactPage/V2/ClickToCall";

import { EscalationActions } from "./EscalationActions";

interface EscalationHeadingProps {
  className?: string;
}

export function EscalationHeading({
  className,
}: EscalationHeadingProps) {
  const { currentEscalation } = useCurrentEscalation();
  const { enabled: canCall, browserEnabled, call, busy: callBusy, targets: callTargets } = useClickToCall();

  const title = useMemo(() => {
    let str = `Escalation`;

    if (currentEscalation?.contact?.name) {
      str += `: ${currentEscalation.contact.name}`;
    }

    if (currentEscalation?.invoice?.xero_number) {
      str += ` | ${currentEscalation.invoice.xero_number}`;
    }

    return str;
  }, [currentEscalation]);

  if (!currentEscalation || !currentEscalation.contact) {
    return null;
  }

  return (
    <Card
      className={ classNames(
        className,
      ) }
    >
      <div>
        { /* Heading & actions row */ }
        <div className={ `flex justify-between` }>
          { /* Heading */ }
          <Heading>
            { title }
          </Heading>
          <div className={ `flex items-center gap-2` }>
            <When condition={ canCall }>
              <CallToolbarButton
                targets={ callTargets }
                browserEnabled={ browserEnabled }
                onCall={ call }
                disabled={ callBusy }
              />
            </When>
            { /* Actions (cancel etc) */ }
            <EscalationActions />
          </div>
        </div>

        { /* Stats */ }
        <ContactStatsDisplay />
      </div>
    </Card>
  );
}
